export const ApplicantGenderEnum = {
    male: 'ذكر',
    female: 'أنثى'
};